export interface Question {
  id: string;
  parentId: string | null;
  content: {
    // { pl: 'blabhlbah', en: 'blahblah' }
    [key: string]: string;
  };
  answerType: string;
}
